/** Placeholder written to the closing-grid export for empty cells. */
export const EMPTY_EXPORT_CELL = '—';

function isEmptyValue(value: unknown): boolean {
  return value == null || (typeof value === 'string' && value.trim() === '');
}

/**
 * Proceeds cell for the closing-grid Excel export. Numeric values (including
 * numeric strings such as "12,500,000") are sent as raw numbers so Excel can
 * sum them; the grid keeps its own thousands-separated display formatting.
 */
export function proceedsExportValue(
  value: string | number | null | undefined,
): string | number {
  if (isEmptyValue(value)) return EMPTY_EXPORT_CELL;
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : EMPTY_EXPORT_CELL;
  }
  const num = Number(String(value).replace(/[,\s]/g, ''));
  return Number.isNaN(num) ? String(value) : num;
}

/**
 * Generic closing-tracker field cell for the export. Only null, undefined and
 * blank strings count as empty, so legitimate `0` / `false` values are kept.
 */
export function fieldExportValue(value: unknown): string | number {
  if (isEmptyValue(value)) return EMPTY_EXPORT_CELL;
  if (typeof value === 'number') return value;
  return String(value);
}
